import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CurrentUserService = /** @class */ (function (_super) {
    tslib_1.__extends(CurrentUserService, _super);
    function CurrentUserService(_http) {
        var _this = _super.call(this, _http, MapperService.userMap) || this;
        _this._http = _http;
        _this._endpoint = '/odata/Users';
        _this.get = function () {
            return _this._http.get(_this._endpoint + "/UiPath.Server.Configuration.OData.GetCurrentUser").pipe(map(function (data) { return data && _this._toDto(data); }));
        };
        return _this;
    }
    CurrentUserService.prototype.login = function (payload) {
        return this._http.post('/account/login', JSON.stringify(payload));
    };
    CurrentUserService.prototype.logout = function () {
        return this._http.get('/account/logout');
    };
    CurrentUserService.prototype.ensureCorrectIdentity = function () {
        return this._http.get('/antiforgery/token', { responseType: 'text' });
    };
    CurrentUserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CurrentUserService_Factory() { return new CurrentUserService(i0.ɵɵinject(i1.HttpClient)); }, token: CurrentUserService, providedIn: "root" });
    return CurrentUserService;
}(ODataService));
export { CurrentUserService };
